import styled from 'styled-components';

export const SettingsRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 5px;

    > * {
        margin-right: 5px;
    }
`;
